import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { ProvinciaService, MenuFuncionService, PaisService } from '../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, Pais, Provincia, SearchPaisRequest, SearchProvinciaRequest } from '../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-provinciaLista',
  templateUrl: './provinciaLista.component.html'
})

export class ProvinciaListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;
  paisList: Pais[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoSearching: boolean = false;
  isPaisSearching: boolean = false;
  canEdit: boolean = false;
  canView: boolean = false;
  canAdd: boolean = false;
  verSoloActivos: boolean = true;
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private service: ProvinciaService,
    private paisService: PaisService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.PROVINCIA).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.PROVINCIA_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.PROVINCIA_LIST);
        if (this.canView){
          this.loadView();
        } else{
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.router.navigate(['/']);
          }
      } else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
        }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getPaises();

    this.menuService.checkMenu(MenuFuncionCodes.PROVINCIA_EDIT).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result)
        this.canEdit = true;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  getPaises() {
    var r = new SearchPaisRequest(null, null, true, "Nombre", null, null, true);
    this.isPaisSearching = true;

    this.paisService.search(r).subscribe(data => {
      this.isPaisSearching = false;
      if (data != null)
        this.paisList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isPaisSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Codigo': [null],
      'Nombre': [null],
      'PaisId': [null]
    });
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Codigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Codigo;
    else
      this.query.addParams("Codigo",this.searchForm.value.Codigo);

    index = this.query.params.findIndex(obj => obj.key === "Nombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Nombre;
    else
      this.query.addParams("Nombre",this.searchForm.value.Nombre);

    index = this.query.params.findIndex(obj => obj.key === "PaisId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PaisId;
    else
      this.query.addParams("PaisId",this.searchForm.value.PaisId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos",this.verSoloActivos.toString());
  }

  add() {
    if(this.canAdd){
      this.router.navigate(['provincia-edit', 0]);
    }else{
      this.sharedFunctions.showMessage("No tiene permisos para crear una nueva provincia", "Error");
    }
  }

  edit(item: Provincia) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['provincia-edit', item.Id]);
  }

  onExport() {
    var search = new SearchProvinciaRequest(null, null, null, "", null, null, null, this.verSoloActivos);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Provincias_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
